module.exports = __webpack_public_path__ + "static/media/InviteEmployees.ef5ddfc6.svg";